import { render, staticRenderFns } from "./trovo.vue?vue&type=template&id=098f8dec&"
import script from "./trovo.vue?vue&type=script&lang=js&"
export * from "./trovo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports